import { db } from '../firebase/config';
import { collection, query, orderBy, limit as fbLimit, onSnapshot } from 'firebase/firestore';

const LAST_READ_KEY = 'ieum.notif.lastReadAt';

export const getLastReadAt = () => {
  const raw = localStorage.getItem(LAST_READ_KEY);
  const n = raw ? Number(raw) : 0;
  return Number.isFinite(n) ? n : 0;
};

export const markAllRead = () => {
  localStorage.setItem(LAST_READ_KEY, String(Date.now()));
};

export const subscribeLatestNoticeTs = (onChange) => {
  const q = query(collection(db, 'notices'), orderBy('createdAt', 'desc'), fbLimit(1));
  return onSnapshot(q, (snap) => {
    const doc = snap.docs[0];
    const ts = doc?.data()?.createdAt?.toMillis?.();
    onChange(Number.isFinite(ts) ? ts : 0);
  }, () => onChange(0));
};
